import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledBox from './styles';

export default function EmptyLayout(props: {children: React.ReactNode}) {
  const { children } = props;

  const { t } = useTranslation();

  return (
    <StyledBox>
      <Box className="header">
        <Typography variant="h1">
          {t('offline.title')}
        </Typography>
      </Box>
      <Box className="main">
        <div className="drawer-placeholder" />
        {children}
      </Box>
    </StyledBox>
  );
}
